// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fonts-page {
  padding: 2rem 0;
  min-height: 80vh;
}

.fonts-page .page-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  text-align: center;
  color: var(--text-primary);
}

/* Fixed Tab Navigation */
.fonts-tabs-nav-fixed {
  position: sticky;
  top: 90px;
  z-index: 100;
  background: var(--bg-primary);
  box-shadow: 0 2px 8px var(--shadow-primary);
  margin-bottom: 1rem;
}

.fonts-tabs-nav-wrapper {
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  justify-content: center;
}

.fonts-tab-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem 1.5rem;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  color: var(--text-secondary);
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  position: relative;
  min-width: 100px;
}

.fonts-tab-button::after {
  content: '';
  position: absolute;
  bottom: -3px;
  left: 0;
  right: 0;
  height: 3px;
  background: transparent;
  transition: background 0.3s ease;
}

.fonts-tab-button:hover {
  color: var(--text-primary);
  background: var(--bg-secondary);
  border-radius: 8px;
}

.fonts-tab-button.active {
  color: var(--accent-primary);
  background: var(--bg-secondary);
  border-radius: 8px;
}

.fonts-tab-button.active::after {
  background: var(--accent-primary);
}

.fonts-tab-icon {
  font-size: 1.5rem;
  line-height: 1;
}

.fonts-tab-label {
  font-size: 0.8rem;
  line-height: 1.2;
  text-align: center;
}

/* Scrollable Content */
.fonts-content-scroll {
  position: relative;
  max-width: 100%;
}

.fonts-content-section {
  margin-bottom: 3rem;
  scroll-margin-top: 140px;
}

.fonts-section-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 2rem 0;
  text-align: center;
}

.fonts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
  padding: 1rem 0;
}

.font-card {
  background: var(--bg-primary);
  border: 2px solid var(--border-primary);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px var(--shadow-primary);
  transition: all 0.3s ease;
}

.font-card:hover {
  border-color: var(--accent-primary);
  box-shadow: 0 8px 16px var(--shadow-primary);
  transform: translateY(-4px);
}

.font-preview-container {
  padding: 2rem;
  background: var(--bg-secondary);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  gap: 1rem;
  overflow: hidden;
}

.font-preview-time {
  color: var(--text-primary);
  /* font-weight: 600; */
  text-align: center;
  line-height: 1.2;
}

.font-preview-numbers {
  color: var(--text-secondary);
  text-align: center;
  line-height: 1.2;
  opacity: 0.8;
}

.font-info {
  padding: 1.5rem;
  background: var(--bg-primary);
}

.font-name {
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: var(--text-primary);
}

.font-filename {
  font-size: 0.85rem;
  color: var(--text-secondary);
  margin: 0;
  font-family: monospace;
}

@media (max-width: 768px) {
  .fonts-tabs-nav-fixed {
    top: 80px;
  }

  .fonts-tabs-nav-wrapper {
    gap: 0.25rem;
    padding: 0.5rem 0.75rem;
  }

  .fonts-tab-button {
    padding: 0.4rem 1rem;
    font-size: 0.8rem;
    gap: 0.2rem;
    min-width: 80px;
  }

  .fonts-tab-icon {
    font-size: 1.3rem;
  }

  .fonts-tab-label {
    font-size: 0.7rem;
    display: block;
  }

  .fonts-content-section {
    margin-bottom: 2rem;
    scroll-margin-top: 100px;
  }

  .fonts-section-title {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .fonts-grid {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 1rem;
  }

  .font-preview-container {
    padding: 1.5rem;
    min-height: 150px;
  }

  .font-info {
    padding: 1rem;
  }

  .font-name {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .fonts-tabs-nav-fixed {
    top: 80px;
  }

  .fonts-tab-button {
    padding: 0.35rem 0.75rem;
    font-size: 0.75rem;
    gap: 0.15rem;
    min-width: 70px;
  }

  .fonts-tab-label {
    display: block;
    font-size: 0.65rem;
  }

  .fonts-tab-icon {
    font-size: 1.2rem;
  }

  .fonts-content-section {
    margin-bottom: 1.5rem;
  }

  .fonts-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .font-preview-container {
    padding: 1rem;
    min-height: 120px;
  }

  .font-info {
    padding: 0.75rem;
  }

  .font-name {
    font-size: 1rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/FontsPage/FontsPage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,6BAA6B;EAC7B,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".fonts-page {\r\n  padding: 2rem 0;\r\n  min-height: 80vh;\r\n}\r\n\r\n.fonts-page .page-title {\r\n  font-size: 2.5rem;\r\n  font-weight: 700;\r\n  margin-bottom: 2rem;\r\n  text-align: center;\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* Fixed Tab Navigation */\r\n.fonts-tabs-nav-fixed {\r\n  position: sticky;\r\n  top: 90px;\r\n  z-index: 100;\r\n  background: var(--bg-primary);\r\n  box-shadow: 0 2px 8px var(--shadow-primary);\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.fonts-tabs-nav-wrapper {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  padding: 0.5rem 1rem;\r\n  justify-content: center;\r\n}\r\n\r\n.fonts-tab-button {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  padding: 0.5rem 1.5rem;\r\n  background: transparent;\r\n  border: none;\r\n  border-bottom: 3px solid transparent;\r\n  color: var(--text-secondary);\r\n  font-weight: 600;\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  white-space: nowrap;\r\n  position: relative;\r\n  min-width: 100px;\r\n}\r\n\r\n.fonts-tab-button::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: -3px;\r\n  left: 0;\r\n  right: 0;\r\n  height: 3px;\r\n  background: transparent;\r\n  transition: background 0.3s ease;\r\n}\r\n\r\n.fonts-tab-button:hover {\r\n  color: var(--text-primary);\r\n  background: var(--bg-secondary);\r\n  border-radius: 8px;\r\n}\r\n\r\n.fonts-tab-button.active {\r\n  color: var(--accent-primary);\r\n  background: var(--bg-secondary);\r\n  border-radius: 8px;\r\n}\r\n\r\n.fonts-tab-button.active::after {\r\n  background: var(--accent-primary);\r\n}\r\n\r\n.fonts-tab-icon {\r\n  font-size: 1.5rem;\r\n  line-height: 1;\r\n}\r\n\r\n.fonts-tab-label {\r\n  font-size: 0.8rem;\r\n  line-height: 1.2;\r\n  text-align: center;\r\n}\r\n\r\n/* Scrollable Content */\r\n.fonts-content-scroll {\r\n  position: relative;\r\n  max-width: 100%;\r\n}\r\n\r\n.fonts-content-section {\r\n  margin-bottom: 3rem;\r\n  scroll-margin-top: 140px;\r\n}\r\n\r\n.fonts-section-title {\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin: 0 0 2rem 0;\r\n  text-align: center;\r\n}\r\n\r\n.fonts-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\r\n  gap: 1.5rem;\r\n  padding: 1rem 0;\r\n}\r\n\r\n.font-card {\r\n  background: var(--bg-primary);\r\n  border: 2px solid var(--border-primary);\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  box-shadow: 0 4px 6px var(--shadow-primary);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.font-card:hover {\r\n  border-color: var(--accent-primary);\r\n  box-shadow: 0 8px 16px var(--shadow-primary);\r\n  transform: translateY(-4px);\r\n}\r\n\r\n.font-preview-container {\r\n  padding: 2rem;\r\n  background: var(--bg-secondary);\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 200px;\r\n  gap: 1rem;\r\n  overflow: hidden;\r\n}\r\n\r\n.font-preview-time {\r\n  color: var(--text-primary);\r\n  /* font-weight: 600; */\r\n  text-align: center;\r\n  line-height: 1.2;\r\n}\r\n\r\n.font-preview-numbers {\r\n  color: var(--text-secondary);\r\n  text-align: center;\r\n  line-height: 1.2;\r\n  opacity: 0.8;\r\n}\r\n\r\n.font-info {\r\n  padding: 1.5rem;\r\n  background: var(--bg-primary);\r\n}\r\n\r\n.font-name {\r\n  font-size: 1.3rem;\r\n  font-weight: 600;\r\n  margin: 0 0 0.5rem 0;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.font-filename {\r\n  font-size: 0.85rem;\r\n  color: var(--text-secondary);\r\n  margin: 0;\r\n  font-family: monospace;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .fonts-tabs-nav-fixed {\r\n    top: 80px;\r\n  }\r\n\r\n  .fonts-tabs-nav-wrapper {\r\n    gap: 0.25rem;\r\n    padding: 0.5rem 0.75rem;\r\n  }\r\n\r\n  .fonts-tab-button {\r\n    padding: 0.4rem 1rem;\r\n    font-size: 0.8rem;\r\n    gap: 0.2rem;\r\n    min-width: 80px;\r\n  }\r\n\r\n  .fonts-tab-icon {\r\n    font-size: 1.3rem;\r\n  }\r\n\r\n  .fonts-tab-label {\r\n    font-size: 0.7rem;\r\n    display: block;\r\n  }\r\n\r\n  .fonts-content-section {\r\n    margin-bottom: 2rem;\r\n    scroll-margin-top: 100px;\r\n  }\r\n\r\n  .fonts-section-title {\r\n    font-size: 1.5rem;\r\n    margin-bottom: 1.5rem;\r\n  }\r\n\r\n  .fonts-grid {\r\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\r\n    gap: 1rem;\r\n  }\r\n\r\n  .font-preview-container {\r\n    padding: 1.5rem;\r\n    min-height: 150px;\r\n  }\r\n\r\n  .font-info {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .font-name {\r\n    font-size: 1.1rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .fonts-tabs-nav-fixed {\r\n    top: 80px;\r\n  }\r\n\r\n  .fonts-tab-button {\r\n    padding: 0.35rem 0.75rem;\r\n    font-size: 0.75rem;\r\n    gap: 0.15rem;\r\n    min-width: 70px;\r\n  }\r\n\r\n  .fonts-tab-label {\r\n    display: block;\r\n    font-size: 0.65rem;\r\n  }\r\n\r\n  .fonts-tab-icon {\r\n    font-size: 1.2rem;\r\n  }\r\n\r\n  .fonts-content-section {\r\n    margin-bottom: 1.5rem;\r\n  }\r\n\r\n  .fonts-grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 1rem;\r\n  }\r\n\r\n  .font-preview-container {\r\n    padding: 1rem;\r\n    min-height: 120px;\r\n  }\r\n\r\n  .font-info {\r\n    padding: 0.75rem;\r\n  }\r\n\r\n  .font-name {\r\n    font-size: 1rem;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
